import React, { createContext, useState } from 'react';
import PropTypes from 'prop-types';

export const ItemFormContext = createContext();

export const ItemFormProvider = ({ children }) => {
  // See itemPropType in constants/propTypes.js for the shape of currentItem
  const [currentItem, setCurrentItem] = useState({});

  return (
    <ItemFormContext.Provider
      value={{
        currentItem,
        setCurrentItem,
      }}>
      {children}
    </ItemFormContext.Provider>
  );
};

ItemFormProvider.propTypes = {
  children: PropTypes.node,
};
